import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type CreateGroupRegularKekApiResponse } from '../services/createRegularKek'

export interface CreateRegularKekState {
  isLoading: boolean
  error: string | undefined
  data: CreateGroupRegularKekApiResponse | undefined
  httpStatus: number | undefined
}

const initialState: CreateRegularKekState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const createRegularKekSlice = createSlice({
  name: 'createRegularKekSlice',
  initialState,
  reducers: {
    createRegularKekLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    createRegularKekUpdateAction: (state, action: PayloadAction<{ data: CreateGroupRegularKekApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    createRegularKekErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  createRegularKekLoadingAction,
  createRegularKekUpdateAction,
  createRegularKekErrorAction
} = createRegularKekSlice.actions

export default createRegularKekSlice.reducer
